import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { EventMantenedorRelatorService } from 'src/app/services/event-mantenedor-relator.service';
import { RelatorService } from 'src/app/services/relator.service';
import { EJECUTOR_OTHERS_ID } from '../../utils/constants';
import { LoginService } from '../../services/login.service';
export class RelatorModalComponent {
    constructor(fb, relatorService, eventMantenedorRelatorService, loginService) {
        this.fb = fb;
        this.relatorService = relatorService;
        this.eventMantenedorRelatorService = eventMantenedorRelatorService;
        this.loginService = loginService;
        this.createEdit = new EventEmitter();
        this.accept = new EventEmitter();
        this.reject = new EventEmitter();
        this.enfoques = [];
        this.categoriesWithFocos = [];
        this.ejecutores = [];
        this.relatorEjecutores = [];
        this.ejecutoresWithRelatores = [];
        this.categoria = {
            relatorId: null,
            descripcion: '',
            estado: true
        };
        this.errors = {
            estado: false,
            zona: false,
            name: false
        };
        this.flags = {
            ejecutor: false,
            relator: false,
            duracionTeorica: false,
            duracionPractica: false,
            fechaEjecucionReal: false,
            Evidencia: false,
            AsignacionParticipantes: false,
            Guardar: false
        };
        this.isRead = false;
        this.flagPassword = false;
        this.showBar = false;
        this.isReadOnEdit = false;
        this.focoCombo = [];
        this.relatorCombo = [];
        this.monthsCombo = [];
        this.ejecutorOthersId = EJECUTOR_OTHERS_ID;
        this.showErrorMessage = false;
        this.showEvidenceMessage = false;
        this.selectedIdZone = null;
        this.confirmationModalHasComment = false;
        this.confirmationModalHasOptions = false;
        this.confirmationModalisCommentObligatory = false;
        this.workersIdSelected = [];
        this.workersSelected = [];
        this.workersColumns = [
            'Rut Trabajador',
            'Nombre',
            'Apellido Paterno',
            'Apellido Materno'
        ];
        this.workersRows = [];
        this.year = new Date().getFullYear();
        this.yearMax = this.year + 4;
        this.loading = false;
        this.evidences = [];
        this.fileData = null;
        this.error = false;
        this.errorMessage = '';
        this.listClass = false;
        this.flagZona = false;
        this.form = this.fb.group({
            evidenceFile: [null]
        });
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.loginService.obtenerPermisosMenu('mantenedores').then((response) => {
                this.rolid = response.data.rolId;
            });
            this.getUltimoId();
            this.selectedIdZone = this.relatorEjecutores.length > 0 ? Object.values(this.relatorEjecutores).map(value => value.ejecutorId) : [];
        });
    }
    getLabel(value, defaultValue) {
        return value ? value.toString() : defaultValue;
    }
    changeInput(field, value, type = '') {
        if (field === 'estadoId') {
            if (value === 'true') {
                this.categoria.estado = true;
            }
            else {
                this.categoria.estado = false;
            }
        }
        this.categoria[field] = value;
    }
    onSave(send = false) {
        this.showErrorMessage = false;
        this.showEvidenceMessage = false;
        if (this.isValid()) {
            this.loading = true;
            if (this.mode === 'Editar') {
                const categoria = this.categoria;
                const request = {
                    newRelator: {
                        relatorId: categoria.relatorId,
                        descripcion: categoria.descripcion,
                        estado: categoria.estado,
                        ejecutores: this.selectedIdZone
                    }
                };
                this.relatorService.update(request)
                    .then(response => {
                    this.createEdit.emit('Relator modificado correctamente');
                    this.eventMantenedorRelatorService.refreshTable();
                    this.loading = false;
                    this.modalCategoria.dismiss('Cancel');
                })
                    .catch(error => console.error(error));
            }
            else {
                const categoria = this.categoria;
                const request = {
                    newRelator: {
                        relatorId: this.ultimoId + 1,
                        descripcion: categoria.descripcion,
                        estado: categoria.estado,
                        ejecutores: this.selectedIdZone
                    }
                };
                this.relatorService.create(request)
                    .then(response => {
                    this.createEdit.emit('Relator creado correctamente');
                    this.eventMantenedorRelatorService.refreshTable();
                    this.loading = false;
                    this.modalCategoria.dismiss('Cancel');
                })
                    .catch(error => console.error(error));
            }
        }
    }
    isValid() {
        let isValid = true;
        const isNameValid = this.categoria.descripcion && this.categoria.descripcion.length <= 50;
        isValid = isValid ? isNameValid : false;
        this.errors.name = !isNameValid;
        if (this.mode == 'Editar') {
            const isEstadoIdValid = this.categoria.estado != null;
            isValid = isValid ? isEstadoIdValid : false;
            this.errors.estado = !isEstadoIdValid;
        }
        const isZonaValid = this.selectedIdZone != null && this.selectedIdZone != '';
        isValid = isValid ? isZonaValid : false;
        this.errors.zona = !isZonaValid;
        return isValid;
    }
    getUltimoId() {
        return new Promise((resolve, reject) => {
            this.relatorService.getUltimoId()
                .then(response => {
                this.ultimoId = response;
            })
                .catch(error => reject(error));
        });
    }
}
